export const MAIN_COLOR = '#4FA444';
export const GRAY_DARKER = '#333';
export const GRAY_DARKER_2 = '#4a4a4a';
export const GRAY_MEDIUM = '#a0a0a0';
export const GRAY_LIGHTER = '#e4e4e4';
export const GRAY_LIGHTER_2 = '#F7F7F7';
export const GRAY_LIGHTER_3 = '#F5F5F5';
export const UHUU_COLOR = '#ee3680';
export const DANGER_COLOR = '#D34848';
export const INFO_COLOR = '#4a90e2';
export const BLUE_LIGHTER = '#a4c7f0';
export const WHITE = '#FFF';
export const GREEN_LIGHTER = '#5BBE4E';
export const GRAY_REGULAR = '#DDDDDD';
export const GRAY_REGULAR_DARK = '#CCCCCC';
export const GRAY_REGULAR_LIGHTER = '#D1D1D1';
export const GRAY_NORMAL_DARK = '#C6C6C6';
export const GRAY_MORE_DARKER = '#404040';
export const BLUE_MARINE = '#4285F4';
export const PLACEHOLDER_COLOR = '#979797';
export const GRAY_NORMAL_LIGHTEST = '#ECECEC';
export const GRAY_LIGHT_ONE = '#F6F6F6';

export const BORDER_RADIUS = '5px';

export const FONT_SIZE_1 = '35px';
export const FONT_SIZE_2 = '30px';
export const FONT_SIZE_3 = '20px';
export const FONT_SIZE_4 = '18px';
export const FONT_SIZE_5 = '16px';
export const FONT_SIZE_6 = '14px';
export const FONT_SIZE_7 = '12px';
export const FONT_SIZE_8 = '10px';

export const FONT_WEIGHT_BOLD = '600';
export const FONT_WEIGHT_NORMAL = '400';

export const COL_SIZE = 67.5;
export const COL_SPACING = 30;
export const FONT_FAMILY = `'Open Sans', Arial, Helvetica, sans-serif`; // eslint-disable-line

export const HEADER_APP_HEIGHT = '60px';
export const HEADER_TITLE_HEIGHT = 170;



// WEBPACK FOOTER //
// ./src/styles/variables.js